<template>
  <div v-if="all_time_list" class="time-slider col mt-3">
    <div class="row justify-content-md-center  alert-light h4">
      Get time
    </div>

    <div class="slidecontainer">
      <input @input="select_time" @click="selected_time" v-model="time_slider" type="range" min="0" :max="len-1" class="slider" id="myRange">
    </div>
    {{epochTime}}
  </div>
</template>


<script>

import axios from 'axios'

export default {

  name: "SliderTimeSelectComponent",

  props: ['camera',],

  data () {
    return {
      time_slider: '',
      len: 0,
      epochTime: '',
      all_time_list: '',
      ge_sid: '',
    }
  },

  created() {
    this.all_time(this.camera)
  },

  methods: {
    select_time () {
      let this_time = parseInt(this.all_time_list[this.time_slider].split('_')[1].split('.')[0]) *1000
      this.epochTime = new Date(this_time).toLocaleString()
    },

    selected_time (){
      this.$emit('selected_time_list', {
          selected_list: this.all_time_list.slice(this.all_time_list.indexOf(this.all_time_list[this.time_slider]))
        })
    },

    all_time(data) {
      this.ge_sid = sessionStorage.getItem('ge_sid')
      const header = {'Content-Type':'application/json', 'Authorization':'Token ' + sessionStorage.getItem('auth_token')} 
      let body = {
        'ge_sid':this.ge_sid,
        'all_period': 0,
        'camera_uid':data.camera_code
        }
      axios({
          method: "post",
          url: "/api/camera-play-list",
          params: body,
          headers: header,
        })
        .then((response) => {
          this.all_time_list = response.data.all_period
          this.time_slider = this.all_time_list.length
          this.len = this.all_time_list.length
        })
        .catch((error) => {
          console.log(error.response.data);
        })
      }
  }
}
</script>



<style scoped>

.slidecontainer {
    width: 100%; /* Width of the outside container */
}

/* The slider itself */
.slider {
    -webkit-appearance: none;  /* Override default CSS styles */
    appearance: none;
    width: 100%; /* Full-width */
    height: 25px; /* Specified height */
    background: #d3d3d3; /* Grey background */
    outline: none; /* Remove outline */
    opacity: 0.7; /* Set transparency (for mouse-over effects on hover) */
    -webkit-transition: .2s; /* 0.2 seconds transition on hover */
    transition: opacity .2s;
}

/* Mouse-over effects */
.slider:hover {
    opacity: 1; /* Fully shown on mouse-over */
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.slider::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    width: 25px; /* Set a specific slider handle width */
    height: 25px; /* Slider handle height */
    background: #4CAF50; /* Green background */
    cursor: pointer; /* Cursor on hover */
}

.slider::-moz-range-thumb {
    width: 25px; /* Set a specific slider handle width */
    height: 25px; /* Slider handle height */
    background: #4CAF50; /* Green background */
    cursor: pointer; /* Cursor on hover */
}
</style>